import { makeStyles } from '@material-ui/core/styles';
import calendarIcon from '@assets/icons/payment/calendar.svg'

export default makeStyles(theme => ({
    root: {
        height: '100px',
        width: '100%',
        // borderBottom: '1px solid #bfbfbf',
        display: 'flex',
        alignItems: 'center',
        '& form': {
            width: '100%'
        },
        '& $button': {
            // color: '#fff',
            // backgroundColor: '#5377f4',
            fontSize: 'inherit',
            // padding: '.65rem 1.25rem',
            '& img$right': {
                marginLeft: '1rem'
            }
        },
    },
    toolbarContainer: {
        width: '100%',
    },
    iconNavigateCalendar: {
        padding: '5px !important',
        minWidth: 'unset',
        color: "#41B60B",
        '&:hover': {
            border: '2px solid #41B60B !important',
          },
        
    },
    calendarBtn: {
        border: "1px solid #41B60B",
        '& .MuiButton-label': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        boder:"1px solid #41B60B",
        '&:hover': {
            border: '2px solid #41B60B',
          },
    },
    btnToday: {
        padding: '5px 25px !important',
        fontSize: '16px',
        color: '#41B60B',
        boder:"1px solid #41B60B ",
        '&:hover': {
            border: '2px solid #41B60B !important',
          },
    },
    searchBar: {
        width: '360px',
        marginBottom: '10px',
        '& .MuiInputBase-input': {
            paddingBottom: '15px'
        },
        '& .MuiInputBase-root': {
            fontSize: '14px',
            fontWeight: '400',
            color: '#808080',
            '&::placeholder': {
                color: '#808080',
            }
        },
        '& .MuiInputBase-root::placeholder': {
            color: '#808080',
        }
    },
    iconSearch: {
        color: '#B3B3B3',
        fontSize: '23px',
        transform: 'rotateY(180deg)'
    },
    buttonSearch: {
        marginBottom: '15px',
        '& .MuiIconButton-root': {
            padding: '7px !important',
            marginBottom: '15px'
        }
    },
    inputDate: {
        '& input':{
            marginLeft: '30px',
            marginRight: '-20px',
            zIndex: '0'
        },
        '&::before ':{
            border: 'none !important'
        },
        "& input[type='date']::-webkit-calendar-picker-indicator": {
            color: 'rgba(0, 0, 0, 0)',
            opacity: 1,
            display: 'flex',
            background: `url(${calendarIcon}) no-repeat`,
            width: '20px',
            height: '20px',
            position: 'absolute',
            left: 0,
            borderWidth: 'thin',
            zIndex: 100,
            cursor: 'pointer',
        }
    },
    walletWrapper: {},
    availableBalances: {},
    balancesText: {},
    textMoney: {},
    textNormal: {},
    button: {},
    right: {},
    paymentActions: {},
    boxLeft: {},
    boxRight: {},
    boxOthers: {},
    boxOthersShow: {},
    boxOthersActive: {},
}))